import React from "react";
import { Spin } from "antd";
import "./index.less"

class Loading extends React.Component {
  render() {
    return (
      <div className="admin-bassic-loading">
        <div className="admin-loading-main">
          <Spin />
        </div>
      </div>
    );
  }
}

export default Loading;